class FilePathAndName {
    constructor() {
        this.name = "";
        this.path = "";
    }
}
export default FilePathAndName